<div class="objekt-struktur-treetable-container mt-4">
  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading object structure...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="error-container">
    <mat-icon class="error-icon">error</mat-icon>
    <p class="error-message">{{ error }}</p>
    <button mat-raised-button color="primary" (click)="loadObjectStructure()">
      <mat-icon>refresh</mat-icon>
      Retry
    </button>
  </div>

  <!-- Controls Section - Always visible when not loading and no error -->
  <div *ngIf="!loading && !error" class="flex items-center justify-between mb-4">
    <div class="flex items-center space-x-4">
      <button mat-stroked-button size="small" (click)="toggleShowIndicators()">
        <mat-icon class="mr-1">{{ showIndicators ? 'visibility_off' : 'visibility' }}</mat-icon>
        {{ showIndicators ? 'Verstecke Indikatoren' : 'Zeige Indikatoren' }}
      </button>
      <mat-slide-toggle [(ngModel)]="showHistory" (change)="onHistoryToggle()" color="primary">
        <span class="ml-2">Zeige Historie</span>
      </mat-slide-toggle>
    </div>
    <button mat-stroked-button size="small" (click)="addGebaeude()">
      <mat-icon class="mr-1">add</mat-icon>
      Neues Gebäude
    </button>
  </div>

  <!-- Tailwind Tree Style with Table Indicators -->
  <div *ngIf="!loading && !error && treeData.length > 0" class="tailwind-tree-content">
    
    <!-- Tailwind Tree Root -->
    <div class="hs-accordion-treeview-root" role="tree" aria-orientation="vertical">
      <!-- 1st Level Accordion Group -->
      <div class="hs-accordion-group" role="group" data-hs-accordion-always-open="">
        <!-- 1st Level Accordion -->
        <ng-container *ngFor="let node of treeData; let i = index">
          <div *ngIf="showHistory || node.data.status == 1"
               class="hs-accordion" 
               [class.active]="node.expanded"
               role="treeitem" 
               [attr.aria-expanded]="node.expanded"
               [id]="'tree-heading-' + i">
             
          
          <!-- 1st Level Accordion Heading -->
          <div class="hs-accordion-heading py-0.5 flex items-center gap-x-0.5 w-full">
            <button class="hs-accordion-toggle size-6 flex justify-center items-center hover:bg-gray-100 rounded-md focus:outline-hidden focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:hover:bg-neutral-700 dark:focus:bg-neutral-700" 
                    [attr.aria-expanded]="node.expanded" 
                    [attr.aria-controls]="'tree-collapse-' + i"
                    (click)="toggleNode(node)">
              <svg class="size-4 text-gray-800 dark:text-neutral-200" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14"></path>
                <path [class]="node.expanded ? 'hidden' : 'block'" d="M12 5v14"></path>
              </svg>
            </button>

            <div class="grow hs-accordion-selectable hs-accordion-selected:bg-gray-100 dark:hs-accordion-selected:bg-neutral-700 px-1.5 rounded-md cursor-pointer"
                 [class.inactive-item]="node.data.status == 0"
                 (click)="toggleNode(node)">
              <div class="flex items-center gap-x-3">
                <mat-icon class="shrink-0 size-4 text-gray-500 dark:text-neutral-500" 
                          [class.inactive-icon]="node.data.status == 0">{{ getNodeIcon(node.data.type) }}</mat-icon>
                <div class="grow">
                  <span class="text-sm text-gray-800 dark:text-neutral-200 font-medium"
                        [class.inactive-text]="node.data.status == 0">
                    {{ node.data.name }}
                  </span>
                  <span *ngIf="node.data.symbol" class="ml-2">{{ node.data.symbol }}</span>
                  
                  <!-- Inactive Badge and Dates for Gebäude (only show for inactive items) -->
                  <span *ngIf="node.data.type === 'gebaeude' && node.data.status == 0" 
                        class="ml-2 inline-flex items-center rounded px-1.5 py-0.5 text-xs font-medium bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200">
                    INAKTIV
                    <span *ngIf="node.data.created_at" class="ml-1">Von: {{ node.data.created_at | date:'dd.MM.yyyy, HH:mm' }}</span>
                    <span *ngIf="node.data.updated_at" class="ml-1">Bis: {{ node.data.updated_at | date:'dd.MM.yyyy, HH:mm' }}</span>
                  </span>
                  
                </div>
                <!-- Additional Info -->
                <div class="flex items-center gap-x-2 text-xs text-gray-500">
                  <span class="type-badge" [class]="'type-' + node.data.type">
                    {{ getTypeLabel(node.data.type) }}
                  </span>
                  <span *ngIf="node.data.type === 'indicator'">
                    {{ node.data.value }} {{ node.data.einheit }}
                  </span>
                  <span *ngIf="node.data.type === 'indicator'" 
                        class="status-indicator"
                        [class]="getBackgroundColorClass(node.data.color)">
                    {{ node.data.color }}
                  </span>
                  <button mat-icon-button size="small" title="Neue Sektion hinzufügen" (click)="addSection(node.data.id); $event.stopPropagation()">
                    <mat-icon>add</mat-icon>
                  </button>
                  <button mat-icon-button size="small" title="Gebäude bearbeiten" (click)="editGebaeude(node.data.id, node.data.name); $event.stopPropagation()">
                    <mat-icon>edit</mat-icon>
                  </button>
                </div>
              </div>
              <!-- Timestamps for inactive items -->
              <div *ngIf="node.data.status === 0 && showHistory" class="mt-1 text-xs text-gray-500 dark:text-gray-400">
                <span *ngIf="node.data.created_at">Erstellt: {{ node.data.created_at | date:'dd.MM.yyyy, HH:mm' }}</span>
                <span *ngIf="node.data.updated_at" class="ml-2">Geändert: {{ node.data.updated_at | date:'dd.MM.yyyy, HH:mm' }}</span>
              </div>
            </div>
          </div>
          <!-- End 1st Level Accordion Heading -->

          <!-- 1st Level Collapse -->
          <div [id]="'tree-collapse-' + i" 
               class="hs-accordion-content w-full overflow-hidden transition-[height] duration-300" 
               role="group" 
               [attr.aria-labelledby]="'tree-heading-' + i"
               [class.hidden]="!node.expanded">
            
            <!-- 2nd Level Accordion Group -->
            <div class="hs-accordion-group ps-7 relative before:absolute before:top-0 before:start-3 before:w-0.5 before:-ms-px before:h-full before:bg-gray-100 dark:before:bg-neutral-700" role="group" data-hs-accordion-always-open="">
              
              <!-- 2nd Level Nested Accordion -->
              <ng-container *ngFor="let child of node.children; let j = index">
                  <div *ngIf="showHistory || child.data.status == 1"
                     class="hs-accordion" 
                     [class.active]="child.expanded"
                     role="treeitem" 
                     [attr.aria-expanded]="child.expanded" 
                     [id]="'tree-sub-heading-' + i + '-' + j">
                   
                
                <!-- 2nd Level Accordion Heading -->
                <div class="hs-accordion-heading py-0.5 flex items-center gap-x-0.5 w-full">
                  <button class="hs-accordion-toggle size-6 flex justify-center items-center hover:bg-gray-100 rounded-md focus:outline-hidden focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:hover:bg-neutral-700 dark:focus:bg-neutral-700" 
                          [attr.aria-expanded]="child.expanded" 
                          [attr.aria-controls]="'tree-sub-collapse-' + i + '-' + j"
                          (click)="toggleNode(child)">
                    <svg class="size-4 text-gray-800 dark:text-neutral-200" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M5 12h14"></path>
                      <path [class]="child.expanded ? 'hidden' : 'block'" d="M12 5v14"></path>
                    </svg>
                  </button>

                  <div class="grow hs-accordion-selectable hs-accordion-selected:bg-gray-100 dark:hs-accordion-selected:bg-neutral-700 px-1.5 rounded-md cursor-pointer"
                       (click)="toggleNode(child)">
                    <div class="flex items-center gap-x-3">
                      <mat-icon class="shrink-0 size-4 text-gray-500 dark:text-neutral-500">{{ getNodeIcon(child.data.type) }}</mat-icon>
                      <div class="grow">
                        <span class="text-sm text-gray-800 dark:text-neutral-200"
                              [class.inactive-text]="child.data.status == 0">
                          {{ child.data.name }}
                        </span>
                        <span *ngIf="child.data.symbol" class="ml-2">{{ child.data.symbol }}</span>
                        
                        <!-- Inactive Badge and Dates for Sektion (only show for inactive items) -->
                        <span *ngIf="child.data.type === 'sektion' && child.data.status == 0" 
                              class="ml-2 inline-flex items-center rounded px-1.5 py-0.5 text-xs font-medium bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200">
                          INAKTIV
                          <span *ngIf="child.data.created_at" class="ml-1">Von: {{ child.data.created_at | date:'dd.MM.yyyy, HH:mm' }}</span>
                          <span *ngIf="child.data.updated_at" class="ml-1">Bis: {{ child.data.updated_at | date:'dd.MM.yyyy, HH:mm' }}</span>
                        </span>
                      </div>
                      <!-- Additional Info -->
                      <div class="flex items-center gap-x-2 text-xs text-gray-500">
                        <span class="type-badge" [class]="'type-' + child.data.type">
                          {{ getTypeLabel(child.data.type) }}
                        </span>
                        <span *ngIf="child.data.type === 'indicator'">
                          {{ child.data.value }} {{ child.data.einheit }}
                        </span>
                        <span *ngIf="child.data.type === 'indicator'" 
                              class="status-indicator"
                              [class]="getBackgroundColorClass(child.data.color)">
                          {{ child.data.color }}
                        </span>
                      </div>
                      <!-- Add Room Button -->
                      <button mat-icon-button size="small" title="Neuen Raum hinzufügen" (click)="addRoom(child.data.id, child.data.name); $event.stopPropagation()">
                        <mat-icon>add</mat-icon>
                      </button>
                      <button mat-icon-button size="small" title="Sektion bearbeiten" (click)="editSection(child.data.id, child.data.name); $event.stopPropagation()">
                        <mat-icon>edit</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
                <!-- End 2nd Level Accordion Heading -->

                <!-- 2nd Level Collapse -->
                <div [id]="'tree-sub-collapse-' + i + '-' + j" 
                     class="hs-accordion-content w-full overflow-hidden transition-[height] duration-300" 
                     role="group" 
                     [attr.aria-labelledby]="'tree-sub-heading-' + i + '-' + j"
                     [class.hidden]="!child.expanded">
                  
                  <!-- 3rd Level Accordion Group -->
                  <div class="hs-accordion-group ps-7 relative before:absolute before:top-0 before:start-3 before:w-0.5 before:-ms-px before:h-full before:bg-gray-100 dark:before:bg-neutral-700" role="group" data-hs-accordion-always-open="">
                    
                    <!-- 3rd Level Accordion -->
                        <ng-container *ngFor="let grandchild of child.children; let k = index">
                          <div *ngIf="showHistory || grandchild.data.status == 1"
                           class="hs-accordion" 
                           [class.active]="grandchild.expanded"
                           role="treeitem" 
                           [attr.aria-expanded]="grandchild.expanded" 
                           [id]="'tree-sub-level-two-heading-' + i + '-' + j + '-' + k">
                      
                      <!-- 3rd Level Accordion Heading -->
                      <div class="hs-accordion-heading py-0.5 flex items-center gap-x-0.5 w-full">
                        <button class="hs-accordion-toggle size-6 flex justify-center items-center hover:bg-gray-100 rounded-md focus:outline-hidden focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:hover:bg-neutral-700 dark:focus:bg-neutral-700" 
                                [attr.aria-expanded]="grandchild.expanded" 
                                [attr.aria-controls]="'tree-sub-level-two-collapse-' + i + '-' + j + '-' + k"
                                (click)="toggleNode(grandchild)">
                          <svg class="size-4 text-gray-800 dark:text-neutral-200" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M5 12h14"></path>
                            <path [class]="grandchild.expanded ? 'hidden' : 'block'" d="M12 5v14"></path>
                          </svg>
                        </button>

                        <div class="grow hs-accordion-selectable hs-accordion-selected:bg-gray-100 dark:hs-accordion-selected:bg-neutral-700 px-1.5 rounded-md cursor-pointer"
                             (click)="toggleNode(grandchild)">
                          <div class="flex items-center gap-x-3">
                            <mat-icon class="shrink-0 size-4 text-gray-500 dark:text-neutral-500">{{ getNodeIcon(grandchild.data.type) }}</mat-icon>
                                                  <div class="grow">
                        <span class="text-sm text-gray-800 dark:text-neutral-200"
                              [class.inactive-text]="grandchild.data.status == 0">
                          {{ grandchild.data.name }}
                        </span>
                        <span *ngIf="grandchild.data.symbol" class="ml-2">{{ grandchild.data.symbol }}</span>
                        
                        <!-- Inactive Badge and Dates for Rooms (only show for inactive items) -->
                        <span *ngIf="grandchild.data.type === 'room' && grandchild.data.status == 0" 
                              class="ml-2 inline-flex items-center rounded px-1.5 py-0.5 text-xs font-medium bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200">
                          INAKTIV
                          <span *ngIf="grandchild.data.created_at" class="ml-1">Von: {{ grandchild.data.created_at | date:'dd.MM.yyyy, HH:mm' }}</span>
                          <span *ngIf="grandchild.data.updated_at" class="ml-1">Bis: {{ grandchild.data.updated_at | date:'dd.MM.yyyy, HH:mm' }}</span>
                        </span>
                        
                        <!-- Indicator Count Badge -->
                        <span *ngIf="grandchild.children && grandchild.children.length > 0" 
                              class="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
                          {{ grandchild.children.length }}
                        </span>
                      </div>
                            <!-- Additional Info -->
                            <div class="flex items-center gap-x-2 text-xs text-gray-500">
                              <span class="type-badge" [class]="'type-' + grandchild.data.type">
                                {{ getTypeLabel(grandchild.data.type) }}
                              </span>
                              <span *ngIf="grandchild.data.type === 'indicator'">
                                {{ grandchild.data.value }} {{ grandchild.data.einheit }}
                              </span>
                              <span *ngIf="grandchild.data.type === 'indicator'" 
                                    class="status-indicator"
                                    [class]="getBackgroundColorClass(grandchild.data.color)">
                                {{ grandchild.data.color }}
                              </span>
                              <!-- Room Edit Button -->
                              <button *ngIf="grandchild.data.type === 'room'" 
                                      mat-icon-button size="small" 
                                      title="Raum bearbeiten" 
                                      (click)="editRoom(grandchild.data.id, grandchild.data.name); $event.stopPropagation()">
                                <mat-icon>edit</mat-icon>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- End 3rd Level Accordion Heading -->

                      <!-- 3rd Level Collapse -->
                      <div [id]="'tree-sub-level-two-collapse-' + i + '-' + j + '-' + k" 
                           class="hs-accordion-content w-full overflow-hidden transition-[height] duration-300" 
                           role="group" 
                           [attr.aria-labelledby]="'tree-sub-level-two-heading-' + i + '-' + j + '-' + k"
                           [class.hidden]="!grandchild.expanded && !showIndicators">
                        
                        <div class="ms-3 ps-3 relative before:absolute before:top-0 before:start-0 before:w-0.5 before:-ms-px before:h-full before:bg-gray-100 dark:before:bg-neutral-700">
                          
                          <!-- Indicators Table - Show when showIndicators is true OR when room is expanded and showIndicators is false -->
                          <div *ngIf="showIndicators || (!showIndicators && grandchild.expanded)" class="indicators-table-container">
                            <!-- Table Header -->
                            <div class="indicators-table-header">
                              <div class="indicator-col-number">Nr.</div>
                              <div class="indicator-col-icon">Symbol</div>
                              <div class="indicator-col-code-type">Code / Systemtyp</div>
                              <div class="indicator-col-position">Position</div>
                              <div class="indicator-col-sw">SW</div>
                              <div class="indicator-col-einheit">Einheit</div>
                              <div class="indicator-col-status">Status</div>
                              <div class="indicator-col-actions">
                                <button mat-icon-button size="small" title="Neuen Indikator hinzufügen" (click)="addIndicator(grandchild.data.id, grandchild.data.name); $event.stopPropagation()">
                                  <mat-icon>add</mat-icon>
                                </button>
                              </div>
                            </div>
                            
                            <!-- Table Body -->
                            <div class="indicators-table-body">
                              <div *ngFor="let indicator of grandchild.children; let l = index" 
                                   class="indicator-table-row">
                                <div class="indicator-col-number">
                                  <span class="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10 dark:bg-blue-400/10 dark:text-blue-400 dark:ring-blue-400/20">
                                    {{ getFormattedIndicatorNumber(indicator.data.indikator_number) }}
                                  </span>
                                </div>
                                <div class="indicator-col-icon">
                                  <img *ngIf="getSymbolUrl(indicator.data.symbol) as symbolUrl" 
                                       [src]="symbolUrl" 
                                       alt="Symbol" 
                                       class="h-6 w-6 object-contain"/>
                                  <mat-icon *ngIf="!getSymbolUrl(indicator.data.symbol)" class="indicator-icon">{{ getNodeIcon(indicator.data.type) }}</mat-icon>
                                </div>
                                <div class="indicator-col-code-type">
                                  <div class="text-sm">
                                    <span class="font-medium">{{ indicator.data.indikator_type || '-' }}</span>
                                    <span *ngIf="indicator.data.indikator_type && indicator.data.indikator_name"> - </span>
                                    <span class="text-gray-500">{{ indicator.data.indikator_name || '' }}</span>
                                  </div>
                                </div>
                                <div class="indicator-col-position">
                                  <span class="text-sm">
                                    {{ indicator.data.name || '-' }}
                                  </span>
                                </div>
                                <div class="indicator-col-sw">
                                  <span class="sw-display text-sm">
                                    {{ indicator.data.schwellenwert }}
                                  </span>
                                </div>
                                <div class="indicator-col-einheit">
                                  <span class="einheit-display text-sm">
                                    {{ indicator.data.einheit }}
                                  </span>
                                </div>
                                <div class="indicator-col-status">
                                  <span class="inline-flex items-center rounded px-1 py-0.5 text-xs font-medium"
                                        [ngClass]="getStatusClasses(indicator.data.status)">
                                    {{ getStatusText(indicator.data.status) }}
                                  </span>
                                </div>
                                <div class="indicator-col-actions">
                                  <button mat-icon-button size="small" title="Bearbeiten" (click)="editIndicator(indicator.data.id, indicator.data.name); $event.stopPropagation()">
                                    <mat-icon>edit</mat-icon>
                                  </button>
                                </div>
                              </div>
                              
                              <!-- Empty state when no indicators -->
                              <div *ngIf="!grandchild.children || grandchild.children.length === 0" 
                                   class="indicator-table-row empty-row">
                                <div class="indicator-col-number">
                                  <span class="text-muted">-</span>
                                </div>
                                <div class="indicator-col-icon">
                                  <mat-icon class="indicator-icon">info</mat-icon>
                                </div>
                                <div class="indicator-col-code-type">
                                  <span class="text-muted">-</span>
                                </div>
                                <div class="indicator-col-position">
                                  <span class="text-muted">-</span>
                                </div>
                                <div class="indicator-col-sw">
                                  <span class="text-muted">-</span>
                                </div>
                                <div class="indicator-col-einheit">
                                  <span class="text-muted">-</span>
                                </div>
                                <div class="indicator-col-status">
                                  <span class="text-muted">-</span>
                                </div>
                                <div class="indicator-col-actions">
                                  <span class="text-muted">-</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- End 3rd Level Collapse -->
                    </div>
                    <!-- End 3rd Level Accordion -->
                    </ng-container>
                  </div>
                  <!-- End 3rd Level Accordion Group -->
                </div>
                <!-- End 2nd Level Collapse -->
              </div>
              <!-- End 2nd Level Nested Accordion -->
              </ng-container>
            </div>
            <!-- End 2nd Level Accordion Group -->
          </div>
          <!-- End 1st Level Collapse -->
        </div>
        <!-- End 1st Level Accordion -->
        </ng-container>
      </div>
      <!-- End 1st Level Accordion Group -->
     <!-- End Tree Root -->
   </div>

   <!-- Print QR Labels Button -->
   <div class="mt-6 flex justify-end">
     <button mat-raised-button color="primary" (click)="printQRLabels()">
       <mat-icon class="mr-2">print</mat-icon>
       Drucken QR-Labels
     </button>
   </div>

   <!-- Empty State -->
   <div *ngIf="!loading && !error && treeData.length === 0" class="empty-container">
     <mat-icon class="empty-icon">account_tree</mat-icon>
     <p class="text-gray-500 text-lg mb-4">Noch keine Objekt-Struktur vorhanden</p>
     <p class="text-gray-400 text-sm">Klicken Sie auf "Neues Gebäude" um mit der Erstellung zu beginnen</p>
   </div>
 </div>
